import { headers } from '@/_services/headers'
import { encrypt, decrypt } from '../../_services/encryption';
const state = {
    dashboardData: null,
    transactionList: null,
    inflowOutflow: [],
    transactionVolume: [],
    mandateAvailablity: [],
    profilePicture: null,
};
const mutations = {
    // set dashboard data
    SET_DASHBOARD_DATA(state, dashboardData) {
        state.dashboardData = dashboardData;
    },
    // set transaction list
    SET_TRANSACTION_LIST(state, transactionList) {
        state.transactionList = transactionList;
    },
    // set inflow outflow
    SET_INFLOW_OUTFLOW(state, inflowOutflow) {
        state.inflowOutflow = inflowOutflow;
    },
    // set mandate availablity
    SET_MANDATE_AVAILABILITY(state, mandateAvailablity) {
        state.mandateAvailablity = mandateAvailablity;
    },
    // get profile picture
    SET_PROFILE_PICTURE(state, profilePicture) {
        state.profilePicture = profilePicture;
    },
    // set transaction volume
    SET_TRANSACTION_VOLUME(state, transactionVolume) {
        state.transactionVolume = transactionVolume;
    },
};
const actions = {
   // get dashboard data
    async getDashboardData({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            const resp = await this._vm.$http.get('https://api.ipify.org?format=json')
            const ip = resp.data.ip
            headers.REMOTE_ADDR = ip
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Customer/getDashboardDetails?platform=1`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_DASHBOARD_DATA', userParseData);
            }
            return response; 
        }
    },
    // get transaction list data
    async getTransactionListData({}, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Transaction/transactionsList`, encryptedData, { headers });
            return response.data;
        }
    },
    // get inflow outflow data
    async getInflowOutflowData({ commit }, { data }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Dashboard/inflowOutflowSummary?accountNumber=${data.accountNumber}&startDate=${data.startDate}&endDate=${data.endDate}`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_INFLOW_OUTFLOW', userParseData);
            } 
            return response;
        }
    },
    // get mandate availablity data
    async getMandateAvailablity({ commit }, data ) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Account/confirmMandateAvailability?accountNumber=${data}`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_MANDATE_AVAILABILITY', userParseData);
            } 
            return response;
        }
    },
    // upload image
    async uploadImage({}, payload) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            headers.Accept = 'multipart/form-data'
            const response = await this._vm.$http.post(`/Customer/UpdateProfileImage`, payload, { headers });
            return response;
        }
    },
    // get profile picture
    async getProfilePicture({ commit }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Customer/getProfilePicture`, encryptedData, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            commit('SET_PROFILE_PICTURE', userParseData);
            return response;
        }
    },
    // get transaction volume
    async getTransactionVolume({ commit }, { data }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Dashboard/transactionVolumeSummary?accountNumber=${data.accountNumber}&startDate=${data.startDate}&endDate=${data.endDate}`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_TRANSACTION_VOLUME', userParseData);
            } 
            return response;
        }
    },
    async deleteProfile({}, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Customer/deleteProfile`, encryptedData, { headers });
            return response;
        }
    },
};
const getters = {
   // get dashboard data
    dashboardDetails: (state) => state.dashboardData,
    transactionList: (state) => state.transactionList,
    inflowOutflow: (state) => state.inflowOutflow,
    mandateAvailablity: (state) => state.mandateAvailablity,
    userAccounts: (state) => state.dashboardData.accounts,
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};